import { __assign, __rest } from "tslib";
import React from 'react';
import { cnAttach } from '../Attach.const';
import './Attach-Control.css';
export var Control = function (_a) {
    var disabled = _a.disabled, id = _a.id, innerRef = _a.innerRef, _b = _a.name, name = _b === void 0 ? 'attachment' : _b, onChange = _a.onChange, accept = _a.accept, props = __rest(_a, ["disabled", "id", "innerRef", "name", "onChange", "accept"]);
    return (React.createElement("input", __assign({}, props, { autoComplete: "off", className: cnAttach('Control'), disabled: disabled, id: id, name: name, onChange: onChange, ref: innerRef, tabIndex: -1, type: "file", accept: accept })));
};
